<template>
  <button :class="['back-to-top', { 'back-to-top--show': showButton }]" @click="scrollToTop">
    <span>
      <slot />
    </span>
  </button>
</template>

<script>
import { debounce } from '@Foundation/utilities';

export default {
  name: 'BackToTop',
  data() {
    return {
      showButton: false,
      aboveTheFoldPadding: 100
    }
  },
  mounted() {
    document.addEventListener("scroll", debounce(this.updateButtonVisibility), 100);
  },
  methods: {
    scrollToTop() {
      document.documentElement.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    updateButtonVisibility() {
      this.showButton = document.documentElement.scrollTop > this.aboveTheFoldPadding;
    }
  }
}
</script>

<style src="./BackToTop.scss" lang="scss">
